<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-toolbar dark color="secondary" max-height="60">
        <v-toolbar-title v-if="showingGrid">{{ $i18n.t("Manage Clients") }}</v-toolbar-title>
        <v-toolbar-title v-if="!showingGrid">{{ $i18n.t("Create Client") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <clients
          :singlePage="true"
          :owner_id="owner_id"
          :showGrid1="false"
          @select="select"
          @closeDialog="closeDialog"
          :showSelectBtn="true"
          @showingGrid="setShowingGrid"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import Clients from "@/views/client/Clients.vue";
import corpService from "@/store/common/module/CorpService";

@Component({
  name: "ClientCreate",
  components: {
    Clients,
  },
  props: {
    showDialog: {
      default: false,
    },
    owner_id: {
      default: null,
    },
  },
})
export default class ClientCreate extends Vue {
  dialog = false;
  showingGrid = false;

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("select", null);
  }

  select(data) {
    this.$emit("select", data);
  }

  setShowingGrid(newVal){
    this.showingGrid = newVal;
  }
}
</script>
